/**
 * @file +layout.ts
 * @author James Bennion-Pedley
 * @brief Top level render strategy
 * @date 10/02/2023
 *
 * @copyright Copyright (c) 2023
 *
 */

/*-------------------------------- Imports -----------------------------------*/

/*--------------------------------- State ------------------------------------*/

/*------------------------------- Functions ----------------------------------*/

/*-------------------------------- Exports -----------------------------------*/

export const prerender = true;
